import { Box } from '@mui/material';
import driveLogo from 'assets/DRIVEtoPROFIT_REVERSE.png';

export function DriveLogo() {
    return <Box component='img' sx={theme => ({ maxHeight: 115 })} src={driveLogo} alt='belnick logo' />;
}
